import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import {
    deletedDepartment,
    deletedRestoreAcademic,
    setDepartment,
    setAcademicRestoreData,
    updateDepartment,
} from "./academicDepartmentSlice";
import { IErrorResponse, IRootState } from "../../../../types";
import { IDepartmentCreate, IDepartmentPayload } from "../types";

const GetDepartment = createAsyncThunk("get/department", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/academic-departments");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;
        dispatch(setDepartment({ data: response.data, defaultLanguage }));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const CreateDepartment = createAsyncThunk("create/department", async (data: IDepartmentCreate, { rejectWithValue }) => {
    try {
        const response = await request.post("/academic-departments", data);
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteDepartment = createAsyncThunk("delete/department", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.delete(`/academic-departments/${id}`);

        dispatch(deletedDepartment(id));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});
const EditDepartment = createAsyncThunk(
    "edit/department",
    async (data: IDepartmentPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/academic-departments/${data.id}`, data);
            dispatch(updateDepartment(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteDepartment = createAsyncThunk("get/delete/department", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/academic-departments/deleted-items`);

        dispatch(setAcademicRestoreData(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteDepartment = createAsyncThunk(
    "restore/delete/department",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/academic-departments/restore/${id}`);

            dispatch(deletedRestoreAcademic(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetDepartment,
    CreateDepartment,
    DeleteDepartment,
    EditDepartment,
    GetDeleteDepartment,
    RestoreDeleteDepartment,
};
